var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData)?_c('div',{staticClass:"space-y-3"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('chart-container',{attrs:{"beginAtZero":true,"chart-type":"bar","chart-data":_vm.chartData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }